import React from 'react'

function PartyPayment() {
  return (
    <div>PartyPayment</div>
  )
}

export default PartyPayment